import React, { useEffect, useContext } from 'react';
import moment from "moment";

// core components
import GridContainer from "beaktShared/components/Grid/GridContainer.js";
import GridItem from "beaktShared/components/Grid/GridItem.js";
import Button from "beaktShared/components/CustomButtons/Button.js";
import { UseGetApiSimple } from "beaktShared/services/crudeApiService";
import ReactHtmlParser, { processNodes, convertNodeToElement, htmlparser2 } from 'react-html-parser';
import SnackbarContent from "beaktShared/components/Snackbar/SnackbarContent.js";


// core icons
import GetAppIcon from '@material-ui/icons/GetApp';
import CircularProgress from '@material-ui/core/CircularProgress';

//services
import { transformValueFloattoFormated, formateDateandTime, formateDate } from "beaktShared/helpers/masks";

// style
import { makeStyles } from "@material-ui/core/styles";
import styles from "assets/jss/BeaktClinic/views/Venda/contratoVenda.js";
import { Table } from '@material-ui/core';
import { SessionContext } from "beaktShared/services/session";

const useStyles = makeStyles(styles);

export default function ContratoVenda(venda) {
  const classes = useStyles();
  const [logo] = React.useState(require("assets/img/LogoEmagrecentro.png"));
  const session = useContext(SessionContext);
  const [listTermos, setlistTermos] = React.useState([]);

  const [dadosContrato, setdadosContrato] = React.useState({
    numeroContrato: "",
    idNetClinicas: "",
    dataEmissao: "",
    clinica_Fantasia: "",
    clinica_RazaoSocial: "",
    clinica_CNPJ: "",
    clinica_Endereco: "",
    cliente_Nome: "",
    Cliente_RG: "",
    cliente_CPF: "",
    cliente_DTNascimento: "",
    cliente_Celular: "",
    cliente_Telefone: "",
    cliente_Email: "",
    cliente_Endereco: "",
    valorTotalServicos: ""
  });

  const html = dadosContrato.clausulaImpressa;

  const [loading, setloading] = React.useState(false);
  const loadTermoServico = () => {
    setloading(true);
    UseGetApiSimple("termoservicos/bycontrato/" + venda.venda.numeroContrato, 0).then(result => {
      setloading(false);
      if (result.status != 200) {
        return false;
      }
      setlistTermos(result.data);
    })
  }

  const openLink = (link) => {
    window.open(link);
  }

  useEffect(() => {
    if (venda.venda != null) {
      setdadosContrato(venda.venda);
      loadTermoServico();
    }
  }, [venda]);

  return (

    <div style={{ marginTop: '0px !important', paddingTop: '0px !important', fontWeight: '400' }}>

      <GridContainer>
        {loading &&
          <div className="carregandoCmp">
            <div className="box">
              <label>Carregando...</label>
              <CircularProgress />
            </div>
          </div>
        }
        <GridItem xs={12} sm={12} md={12}>
          {venda.venda.usuarioCancelamento &&  <div className="no-print" style={{ padding: '0px 30px' }}>
          <SnackbarContent   
            color={"warning"}
            message={"Contrato cancelado no dia "+ formateDateandTime(venda.venda.dataCancelamento) + " pelo usuário " + venda.venda.usuarioCancelamento + ". (Possui transação ESitef: " + (venda.venda.possuiESITEF ? "Sim" : "Não") + " / Possui transação Sitef: " + (venda.venda.possuiSITEF ? "Sim" : "Não") + ")"}        
            />
          </div>}
          <div className="no-print" style={{ padding: '5px 30px' }}>
            <Button
              color="info"
              className={classes.marginRight}
              onClick={() => window.print()}
            >
              Imprimir Contrato
            </Button>
            {listTermos.map(item => (
              <Button key={item.titulo}
                color="secondary"
                className={classes.marginRight}
                onClick={() => openLink(item.nomeArquivo)}
              ><GetAppIcon className={classes.icons} />
                {item.titulo}
              </Button>
            ))
            }
          </div>

          <div className="allowPrint"
            style={{ color: 'black', maxWidth: '900px', margin: '0 auto', border: '1px solid rgb(206, 206, 206)', background: 'white', padding: '20px 30px', fontWeight: '400' }}>
            <table>
              <thead>
                <tr>
                  <th>
                    <img src={logo} style={{ width: '300px', marginTop: '20px' }} />
                    <div style={{ float: 'right', textAlign: 'right' }}>
                      <h3>Nº do Contrato: {dadosContrato.idNetClinicas}</h3>
                      <h4>Data de Emissão: {formateDateandTime(dadosContrato.dataEmissao)}</h4>
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <div style={{ fontSize: '1.2em', marginBottom: '25px' }}>
                      <h3 style={{ textAlign: 'center' }}>CONTRATADO</h3>
                      <hr className="linha" />
                      <p> <b>CLÍNICA: </b> {dadosContrato.clinica_Fantasia} </p>
                      <p> <b>RAZÃO SOCIAL: </b> {dadosContrato.clinica_RazaoSocial} </p>
                      <p> <b>CNPJ: </b> {dadosContrato.clinica_CNPJ} </p>
                      <p> <b>ENDEREÇO: </b> {dadosContrato.clinica_Endereco}</p>
                    </div>

                    <div style={{ fontSize: '1.2em', marginBottom: '25px' }}>
                      <h3 style={{ textAlign: 'center' }}>CONTRATANTE</h3>
                      <hr className="linha" />
                      <p> <b>NOME: </b> <span style={{ textTransform: "Uppercase" }}>{dadosContrato.cliente_Nome}&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; </span> <b style={{ paddingLeft: "15px" }}>RG: </b> {dadosContrato.cliente_RG}</p>
                      <p><b>CPF: </b><span>{dadosContrato.cliente_CPF}&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; </span><b>DT NASC: </b>{dadosContrato.cliente_DTNascimento != null ? formateDate(dadosContrato.cliente_DTNascimento) : ''} </p>
                      <p> <b>CEL: </b><span>{dadosContrato.cliente_Celular}&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; </span> <b style={{ paddingLeft: "15px" }}>E-MAIL: </b> {dadosContrato.cliente_Email} </p>
                      <p> <b>ENDEREÇO: </b> {dadosContrato.cliente_Endereco}</p>
                    </div>

                    {(dadosContrato.produtos && dadosContrato.produtos.length > 0) &&
                      <div style={{ fontSize: '1.2em', marginBottom: '10px' }}  className={classes.pageBreak}>
                        <h3 style={{ textAlign: 'center' }}>Produtos</h3>
                        <table className="tabelaItem6" >
                          <thead className="head-table">
                            <tr style={{ background: '#F5F5F5' }}>
                              <th>&nbsp;TIPO</th>
                              <th>&nbsp;DESCRIÇÃO</th>
                              <th className="text-center">QTD</th>
                              <th className="text-right">R$ Unit.&nbsp;</th>
                              <th className="text-right">R$ Desc&nbsp;</th>
                              <th className="text-right">R$ Liquído&nbsp;</th>
                            </tr>
                          </thead>
                          <tbody>
                            {dadosContrato.produtos && dadosContrato.produtos.map(item => (
                              <tr>
                                <td>&nbsp;{item.tipo}</td>
                                <td>&nbsp;{item.descricao}</td>
                                <td className="text-center">{item.qtd}</td>
                                <td className="text-right">{transformValueFloattoFormated(item.valorUnitario)}&nbsp;</td>
                                <td className="text-right">{transformValueFloattoFormated(item.valorDesconto)}&nbsp;</td>
                                <td className="text-right">{transformValueFloattoFormated(item.valorLiquido)}&nbsp;</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>

                        <div style={{ textAlign: 'right' }}>
                          <h5><b>Total: {transformValueFloattoFormated(dadosContrato.valorTotalProdutos)}</b></h5>
                        </div>
                      </div>
                    }

                    {(dadosContrato.servicos && dadosContrato.servicos.length > 0) &&
                      <div style={{ fontSize: '1.2em', marginBottom: '10px' }}  className={classes.pageBreak}>
                        <h3 style={{ textAlign: 'center' }}>Serviços</h3>
                        <table className="tabelaItem6">
                          <thead className="head-table">
                            <tr style={{ background: '#F5F5F5' }}>
                              <th>&nbsp;TIPO</th>
                              <th>&nbsp;DESCRIÇÃO</th>
                              <th className="text-center">QTD</th>
                              <th className="text-right">R$ Unit.&nbsp;</th>
                              <th className="text-right">R$ Desc&nbsp;</th>
                              <th className="text-right">R$ Liquído&nbsp;</th>
                            </tr>
                          </thead>
                          <tbody>
                            {dadosContrato.servicos && dadosContrato.servicos.map(item => (
                              <tr>
                                <td>&nbsp;{item.tipo}</td>
                                <td>&nbsp;{item.descricao}</td>
                                <td className="text-center">{item.qtd}</td>
                                <td className="text-right">{transformValueFloattoFormated(item.valorUnitario)}&nbsp;</td>
                                <td className="text-right">{transformValueFloattoFormated(item.valorDesconto)}&nbsp;</td>
                                <td className="text-right">{transformValueFloattoFormated(item.valorLiquido)}&nbsp;</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>

                        <div style={{ textAlign: 'right' }}>
                          <h5><b>Total: {transformValueFloattoFormated(dadosContrato.valorTotalServicos)}</b></h5>
                        </div>
                      </div>
                    }

                    {(dadosContrato.pacotes && dadosContrato.pacotes.length > 0) &&
                      <div style={{ fontSize: '1.2em', marginBottom: '10px' }} className={classes.pageBreak}>
                        <h3 style={{ textAlign: 'center' }}>Pacotes</h3>
                        <table className="tabelaItem6">
                          <thead className="head-table">
                            <tr style={{ background: '#F5F5F5' }}>
                              <th>&nbsp;TIPO</th>
                              <th>&nbsp;DESCRIÇÃO</th>
                              <th className="text-center">QTD</th>
                              <th className="text-right">R$ Unit.&nbsp;</th>
                              <th className="text-right">R$ Desc&nbsp;</th>
                              <th className="text-right">R$ Liquído&nbsp;</th>
                            </tr>
                          </thead>
                          <tbody>
                            {dadosContrato.pacotes && dadosContrato.pacotes.map(item => (
                              <tr>
                                <td>&nbsp;{item.tipo}</td>
                                <td>
                                  <b>&nbsp;Descrição: </b>
                                  {item.descricao}
                                  <br /><br />
                                  <b>Serviços: </b>
                                  {JSON.stringify(item.pacoteServico).replaceAll("\"", "").replaceAll("[", "").replaceAll("]", "")}
                                  <br /><br />
                                  <b>Produtos: </b>
                                  {JSON.stringify(item.pacoteProdutos).replaceAll("\"", "").replaceAll("[", "").replaceAll("]", "")}
                                </td>
                                <td className="text-center">{item.qtd}</td>
                                <td className="text-right">{transformValueFloattoFormated(item.valorUnitario)}&nbsp;</td>
                                <td className="text-right">{transformValueFloattoFormated(item.valorDesconto)}&nbsp;</td>
                                <td className="text-right">{transformValueFloattoFormated(item.valorLiquido)}&nbsp;</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>

                        <div style={{ textAlign: 'right' }}>
                          <h5><b>Total: {transformValueFloattoFormated(dadosContrato.valorTotalPacotes)}</b></h5>
                        </div>
                      </div>
                    }
                    <div style={{ fontSize: '1.2em', marginBottom: '25px' }}>
                      <h3 style={{ textAlign: 'center' }}>&nbsp;Total Itens</h3>
                      <table className="tabelaItem6" border="1">
                        <tr>
                          <td style={{ padding: '.75rem' }}>&nbsp;Recebemos do cliente acima descrito, a importância de: </td>
                          <td style={{ padding: '.75rem' }} className='text-right'><b>{transformValueFloattoFormated((dadosContrato.valorTotalPacotes) + (dadosContrato.valorTotalServicos) + (dadosContrato.valorTotalProdutos))}</b>&nbsp;</td>
                        </tr>
                      </table>
                    </div>

                    <div className={classes.termosContrato} style={{ fontSize: '1.2em', marginBottom: '25px' }}>
                      {(html != null && html != "") && ReactHtmlParser(html)}
                      {(html == null || html == "") &&
                        <>
                          <h3>TERMOS DO CONTRATO</h3>
                          <p>
                            1- O cliente acima qualificado, doravante simplesmente denominado “CONTRATANTE”, fica
                            responsável pelas informações fornecidas ao EMAGRECENTRO (doravante simplesmente
                            denominado “CONTRATADO”) referentes à sua saúde - incluindo, mas não se limitando, ao porte
                            de doença contagiosa, gravidez, cirurgia, uso de “diu”, marca passos, alergias e medicações
                            utilizadas -, sendo que qualquer omissão ou desconhecimento da CONTRATANTE quanto aos
                            mencionados itens isenta totalmente o CONTRATADO de e qualquer responsabilidade com
                            relação a efeitos colaterais, sequelas, ou problemas que advenham da pré-existência omitida.
                            <br /> <br />
                          </p>
                          <p className="font-weight-bold">
                            2- Iniciado o tratamento, a CONTRATANTE deverá seguir os prazos determinados na
                            escolha do 'pacote', sendo certo que deverá terminar seu tratamento no prazo máximo de
                            90(noventa) dias da assinatura do contrato.Após transcorrido tal prazo, em vista do
                            abandono, a mesma perderá o direito ao tratamento contratado.
                            <br /> <br />
                          </p>
                          <p>
                            3- Em caso de pagamento com cheques, o recebimento se dará a título pró-solvendo, efetivando-se
                            o pagamento somente com a compensação dos mesmos.
                            <br /> <br />
                          </p>
                          <p>
                            4- No caso do cheque não compensar na data estipulada o mesmo estará sujeito a protesto, bem
                            como o nome da contratante poderá ser inserido em bancos de dados de proteção ao crédito
                            (SPC/SERASA).
                            <br /> <br />
                          </p>
                          <p>
                            5- A CONTRATANTE está adquirindo um pacote promocional e gozará do preço promocional
                            para o cumprimento INTEGRAL do tratamento, devendo ser observados os dispostos nos itens 1
                            a 4 deste contrato.
                            <br /> <br />
                          </p>
                          <p className="font-weight-bold">
                            6- Em caso de desistência, a CONTRATANTE perderá o direito aos valores promocionais,
                            devendo pagar pelos serviços prestados pelo CONTRATADO até o momento da rescisão
                            de acordo com o valor descrito na lista abaixo, acrescidos de multa rescisória de 10%
                            (dez por cento) sobre o valor total do contrato: <br></br><br></br>
                          </p>
                          <p>
                            {(dadosContrato.servicosTodos && dadosContrato.servicosTodos.length > 0) &&

                              <table className="tabelaItem6" style={{ border: 'solid', borderWidth: '1px' }}>
                                <thead className="head-table">
                                  <tr style={{ background: '#F5F5F5' }}>
                                    <th className="text-center" >DESCRIÇÃO</th>
                                    <th className="text-center" style={{ textAlign: 'right' }}>R$ Unit.</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {dadosContrato.servicosTodos && dadosContrato.servicosTodos.map(item => (
                                    <tr>
                                      <td>&nbsp; {item.descricao}</td>
                                      <td style={{ textAlign: 'right' }}>{transformValueFloattoFormated(item.valorUnitario)}&nbsp; </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            }
                          </p>
                          <p>
                            6.1- Em caso de cancelamento do pacote as sessões realizadas serão debitadas do valor a
                            ser devolvido
                            <br /> <br />
                          </p>
                          <p>
                            7- Entende-se por formalização de desistência, o pedido por escrito, feito pela CONTRATANTE
                            perante a sede do CONTRATADO, com antecedência mínima de 48 (quarenta e oito) horas.
                            <br /> <br />
                          </p>
                          <p>
                            8- O presente contrato tem validade até o término do(s) tratamento(s) contratado(s) ou até
                            transcorrido o prazo determinado no item 2, o que ocorrer primeiro.
                            <br /> <br />
                          </p>
                          <p>
                            9- A CONTRATANTE tem ciência que os procedimentos realizados com equipamentos/produtos
                            utilizados pelos profissionais do CONTRATADO podem provocar eventuais hematomas e
                            inchaços, dependendo da sensibilidade cutânea de cada cliente.Declara a CONTRATANTE que
                            foi devidamente orientada e que possui total conhecimento dos possíveis efeitos e consequência
                            de cada tratamento contratado.Declara a CONTRATANTE, ainda, estar ciente de que não
                            poderá, durante o tratamento, tomar banho de sol nas regiões onde aparecerem hematomas e
                            inchaços.
                            <br /> <br />
                          </p>
                          <p>
                            10- É de conhecimento da CONTRATANTE que o CONTRATADO não pode dar garantias em
                            relação ao tratamento, uma vez que seus resultados dependem do rigor da CONTRATANTE em
                            relação a sua aderência ao tratamento e do metabolismo da própria CONTRATANTE, ficando
                            claro que a prática da medicina não é exata (quando trata-se de tratamento médico-estético).
                            Diante do exposto, a CONTRATANTE aceita expressamente o fato de que não podem ser dadas
                            garantias de resultados aos procedimentos e declara estar ciente de que deve seguir
                            rigorosamente os procedimentos complementares e coadjuvantes, como as dietas, orientações
                            nutricionais e realização de atividades físicas paralelas.
                            <br /> <br />
                          </p>
                          <p>
                            11- Fica a CONTRATANTE ciente que o consumo de fumo em excesso, álcool ou açúcar, podem
                            afetar ou prejudicar o resultado do tratamento.
                            <br /> <br />
                          </p>
                          <p>
                            12- Caso a CONTRATANTE marque horário para fazer um procedimento estético e não possa
                            comparecer, deverá ser feita a desmarcação deste procedimento com antecedência mínima de
                            24 (vinte e quatro) horas, sob pena de o procedimento ser considerado como realizado, não
                            tendo a CONTRATANTE direito a reposição.
                            <br /> <br />
                          </p>
                          <p>&nbsp; 13 – A CONTRATANTE, por este ato, autoriza o CONTRATADO e as demais unidades da rede
                            Emagrecentro a &nbsp; divulgarem sua imagem em anúncios que poderão ser veiculados nacional ou
                            internacionalmente por qualquer &nbsp; meio de divulgação - incluindo mídias online e offline, tais como
                            mídias impressas, mídias eletrônicas de todas &nbsp; as espécies, malas diretas, cartazes, faixas,
                            folhetos, etc - pelo período de 05 (cinco) anos contados da data de &nbsp; assinatura do presente
                            instrumento, não sendo o CONTRATADO e as demais unidades da rede Emagrecentro
                            &nbsp; responsáveis pela recolha dos materiais expedidos após este prazo, mas apenas e tão somente
                            por cessar a &nbsp; produção/confecção de materiais contendo as imagens da CONTRATANTE.
                          </p>
                          <p>
                            &nbsp; 13.1- Declara a CONTRATANTE, ainda, ter ciência que a cessão do direito de uso das imagens é
                            feito a título &nbsp; gratuito.<br></br><br></br>
                          </p>
                          <p>
                            &nbsp; 13.2- Todos os atos previstos nesta cláusula independem, portanto, de nova e expressa
                            concordância da &nbsp; CONTRATANTE, com o que esta desde já anui.
                            <br /><br />
                            &nbsp; Visto e de Acordo: ____________________________________<br />
                            <div>&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                              &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                              &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                              CONTRATANTE</div>
                          </p>
                          <p>
                            <br /> <br />
                            14- Neste ato a CONTRATANTE está recebendo cópia do presente contrato, CUJO
                            CONTEÚDO DECLARA TER LIDO CONCORDADO EXPRESSAMENTE, assinando o presente
                            em duas vias.
                          </p>
                          <p>
                            <br></br>
                            Declaro que fui informado (a) e compreendi que a prática médica não é uma ciência exata, não
                            podem ser dadas garantias nem certeza quanto ao tratamento ou resultados.Declaro, ainda, ter
                            sido previamente informado (a) sobre todos os benefícios, riscos, indicações, contra-indicações,
                            principais efeitos colaterais e advertências gerais, relacionadas aos procedimentos ora
                            contratados, sendo que referidas informações foram suficientemente claras e elucidativas.
                          </p>
                          <p>
                            <br /> <br />
                            Reconheço e autorizo o débito aqui indicado em meu cartão de crédito ou confirmo o pagamento
                            em cheque ou dinheiro.
                          </p>
                        </>
                      }
                    </div>

                    <div style={{ fontSize: '1.2em', marginBottom: '5px !important', paddingBottom: '0px !important' }}>
                      <h3>Forma de Pagamento</h3>
                      <table className="tabelaItem6">
                        <thead className="head-table">
                          <tr style={{ background: '#F5F5F5' }}>
                            <th>&nbsp;FORMA</th>
                            <th>&nbsp;DETALHE</th>
                            <th style={{ textAlign: 'right' }}>R$ Valor&nbsp;</th>
                          </tr>
                        </thead>
                        <tbody>
                          {dadosContrato.pagamentos && dadosContrato.pagamentos.map(item => (
                            <tr>
                              <td style={{ fontSize:'0.9em'}}>&nbsp;{item.forma}</td>
                              <td>&nbsp;
                                {
                                  item.detalhe.split("<br/>").map(_detalhe => (
                                    <div style={{ fontSize:'0.9em'}}>{_detalhe}<br /></div>
                                  ))
                                }
                              </td>
                              <td style={{ textAlign: 'right', fontSize:'0.9em' }}>{transformValueFloattoFormated(item.valor)}&nbsp;</td>
                            </tr>
                          ))
                          }
                        </tbody>
                      </table>

                      <br />
                      <br />
                      <br />
                      <GridContainer>

                        <GridItem xs={12} sm={6} md={6}>
                          <p style={{ textAlign: 'center', fontWeight: '400' }}>
                            ______________________________________<br />
                            Contratado
                          </p>
                        </GridItem>

                        <GridItem xs={12} sm={6} md={6}>
                          <p style={{ textAlign: 'center', fontWeight: '400' }}>
                            ______________________________________<br />
                            Contratante
                          </p>
                        </GridItem>

                      </GridContainer>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

        </GridItem >

      </GridContainer >

    </div >
  );
}